import {Component, Input} from '@angular/core';
import {RouterLink, RouterLinkActive} from '@angular/router';
import {HighlightPipe} from '../pipes/highlight.pipe';

@Component({
  selector: 'app-single-forum-small-view',
  templateUrl: './single-forum-small-view.component.html',
  imports: [
    RouterLink,
    HighlightPipe,
    RouterLinkActive
  ],
  styleUrls: ['./single-forum-small-view.component.scss']
})
export class SingleForumSmallViewComponent {

  @Input() blogPostData: any;
  @Input() searchQuery = '';
}
